import { Utils } from '@/plugin/gis-viewer/Utils'
import DrawOverlaysPGIS from '@/plugin/gis-viewer/widgets/DrawOverlays/pgis/DrawOverlaysPGIS'
import GeometrySearchPGIS from '@/plugin/gis-viewer/widgets/GeometrySearch/pgis/GeometrySearchPGIS'
import HeatMapPGIS from '@/plugin/gis-viewer/widgets/HeatMap/pgis/HeatMapPGIS'
import POISearchPGIS from '@/plugin/gis-viewer/widgets/POISearch/pgis/POISearchPGIS'
import PolylineRangingPGIS from '@/plugin/gis-viewer/widgets/Ranging/pgis/PolylineRanging'
import TrackPlaybackPGIS from '@/plugin/gis-viewer/widgets/TrackPlayback/pgis/TrackPlayback'
// import HomeOverlayPGIS from "@/plugin/gis-viewer/widgets/Overlays/pgis/HomeOverlay";
import {
  IBoundary,
  ICenterLevel,
  ICustomTip,
  IDefinitionParameter,
  IDistrictParameter,
  IDrawOverlays,
  IFindParameter,
  IGeometrySearchParameter,
  IHeatImageParameter,
  IHeatParameter,
  ILayerConfig,
  IMapContainer,
  IOverlayClusterParameter,
  IOverlayDelete,
  IOverlayParameter,
  IPicChangeParameter,
  IPointGeometry,
  IPolylineRangingParameter,
  IPopUpTemplate,
  IResult,
  ISelectRouteHitTest,
  ISelectRouteParam,
  ISelectRouteResult,
  ISignalPhaseInfo,
  IStreetParameter,
  ISumoConnectInfo,
  ITrackParameter,
  ITrackPlaybackParameter,
  IWidget
} from '@/types/map'
import { loadCss } from 'esri-loader'
import OverlayPGIS from './widgets/Overlays/pgis/OverlayPGIS'
import RoutePGIS from './widgets/Route/pgis/RoutePGIS'
import WidgetsManagerPGIS from './widgets/WidgetsManager/pgis/WidgetsManagerPGIS'

declare let ol: any
declare let FMap: any
declare let FDataService: any
export default class MapAppPGIS_LS implements IMapContainer {
  public fmap!: any //pgis基于ol的封装
  public view!: any ///实际上是openlayer中的map对象
  public baseLayers: Array<any> = []
  public layerLoaded: any
  public showGisDeviceInfo: any
  public mapClick: any
  public drawCallback: any

  private hlLayer: any

  public async initialize(mapConfig: any, mapContainer: string): Promise<any> {
    const apiUrl =
      mapConfig.pgis_api ||
      mapConfig.apiUrl ||
      mapConfig.arcgis_api ||
      mapConfig.api_url
    const olConfig = apiUrl + '/olConfig.js'
    const olUrl = apiUrl + '/ol.js'
    const fMap_ol = apiUrl + '/FMap-OpenLayers.js'
    const olCss = apiUrl + '/ol.css'
    //const proj4 = "https://cdn.bootcss.com/proj4js/2.5.0/proj4.js";

    //原版
    await Utils.loadScripts([olConfig, olUrl]).then(async () => {
      await Utils.loadScripts([fMap_ol])
      await Utils.loadCss([olCss])
      console.log('css and scripts loaded!')
    })

    let widgetStyle = mapConfig.widgetStyle
      ? mapConfig.widgetStyle
      : 'assets/styles/style'
    let customcssFile: string = widgetStyle + '/dark.css'
    if (mapConfig.theme && mapConfig.theme.indexOf('light') > -1) {
      customcssFile = widgetStyle + '/light.css'
    }
    loadCss(customcssFile)
    let options = mapConfig.options
    if (!options.proj) {
      options.proj = 'EPSG:4326'
    }
    const fmap = new FMap()

    let view: any
    if (options.basemap) {
      view = fmap.initMap(mapContainer, options)
    } else {
      let baseLayers: Array<any> = new Array<any>()
      if (mapConfig.baseLayers) {
        baseLayers = mapConfig.baseLayers.map((layerConfig: any) => {
          let baseLayer
          if (layerConfig.type === 'tiled') {
            baseLayer = new ol.layer.Tile({
              source: new ol.source.TileArcGISRest({
                projection: layerConfig.proj || options.proj,
                url: layerConfig.url
              }),
              visible: layerConfig.visible !== false
            })
          } else if (layerConfig.type === 'webtiled') {
            baseLayer = new ol.layer.Tile({
              source: new ol.source.XYZ({
                url: layerConfig.url
              }),
              visible: layerConfig.visible !== false
            })
          } else if (layerConfig.type === 'dynamic') {
            baseLayer = new ol.layer.Image({
              source: new ol.source.ImageArcGISRest({
                ratio: 1,
                params: {},
                url: layerConfig.url
              }),
              visible: layerConfig.visible !== false
            })
          }
          baseLayer.label = layerConfig.label
          fmap.basisMapService.basemaplayers.push(baseLayer)
          return baseLayer
        })
      }
      if (options.proj && options.proj === 'EPSG:3857') {
        options.center = await this.corTransform(options.center)
      }
      let mapObj = new ol.Map({
        view: new ol.View({
          projection: options.proj,
          ...options
        }),
        layers: baseLayers,
        target: mapContainer
      })
      view = fmap.initByMap(options, mapObj)
    }
    this.fmap = fmap
    this.view = view
    this.view.fmap = fmap
    //处理optionalLayers
    if (mapConfig.operationallayers && mapConfig.operationallayers.length) {
      this.createLayers(mapConfig.operationallayers, options.proj)
    }
    //地图图层加载
    let mapLoadPromise = new Promise((resolve) => {
      view.once('postrender', (results: any) => {
        resolve(results)
      })
    })
    //加载完成
    let _this = this
    await mapLoadPromise.then(async () => {
      console.log('map Loaded!')
      view.on('click', (evt: any) => {
        let mp = evt.coordinate
        _this.mapClick({ x: mp[0], y: mp[1], lat: mp[0], lnt: mp[1] })
        var pixel = view.getEventPixel(evt.originalEvent)
        var feature = view.forEachFeatureAtPixel(
          evt.pixel,
          (feature: any, layer: any) => {
            return feature
          }
        )
        if (feature) {
          _this.showGisDeviceInfo(feature.type, feature.id, feature)
        }
      })
    })
    if (mapConfig.widgets) {
      this.showWidgetTools(mapConfig.widgets)
    }
  }

  private async corTransform(center: number[]) {
    return await ol.proj.transform(center, 'EPSG:4326', 'EPSG:3857')
  }

  private async createLayers(layers: any[], proj: string) {
    let oplayers = layers.map((layerConfig: any) => {
      let singleLayer
      if (layerConfig.type === 'tiled') {
        singleLayer = new ol.layer.Tile({
          source: new ol.source.TileArcGISRest({
            projection: layerConfig.proj || proj,
            url: layerConfig.url
          }),
          visible: layerConfig.visible !== false
        })
      } else if (layerConfig.type === 'webtiled') {
        singleLayer = new ol.layer.Tile({
          source: new ol.source.XYZ({
            url: layerConfig.url
          }),
          visible: layerConfig.visible !== false
        })
      } else if (layerConfig.type === 'dynamic') {
        singleLayer = new ol.layer.Image({
          source: new ol.source.ImageArcGISRest({
            ratio: 1,
            params: {},
            url: layerConfig.url
          }),
          visible: layerConfig.visible !== false
        })
      }
      singleLayer.label = layerConfig.label
      this.view.addLayer(singleLayer)
      this.fmap.basisMapService.basemaplayers.push(singleLayer)
      return singleLayer
    }, this)
  }

  private async processBaseLayers(params: any[]): Promise<any> {
    params.forEach((baseLayer: any) => {
      if (baseLayer.type === 'tiled') {
        const url = baseLayer.url
        const platform = baseLayer.platform
        if (platform === 'arcgis') {
          const tileLayer = new ol.layer.Tile({
            source: new ol.source.TileArcGISRest({
              projection: 'EPSG:4326',
              url: url
            })
          })

          const baseLayers = this.fmap.basisMapService.basemaplayers //现有底图数组
          baseLayers.push(tileLayer)
          this.view.addLayer(tileLayer)
        }
      }
    })
  }

  /*************************overlays ********/
  public async addOverlays(params: IOverlayParameter): Promise<IResult> {
    const overlay = OverlayPGIS.getInstance(this.view, this.fmap)
    return await overlay.addOverlays(params)
  }
  public async deleteOverlays(params: IOverlayDelete): Promise<IResult> {
    const overlay = OverlayPGIS.getInstance(this.view, this.fmap)
    return await overlay.deleteOverlays(params)
  }
  public async deleteAllOverlays() {
    const overlay = OverlayPGIS.getInstance(this.view, this.fmap)
    return await overlay.deleteAllOverlays()
  }
  public async getOverlays(params: IOverlayDelete): Promise<IResult> {
    const overlay = OverlayPGIS.getInstance(this.view, this.fmap)
    return await overlay.getOverlays(params)
  }
  public async hideOverlays(param: IOverlayDelete): Promise<any> {
    const overlays = OverlayPGIS.getInstance(this.view, this.fmap)
    return await overlays.hideOverlays(param)
  }
  public async showOverlays(param: IOverlayDelete): Promise<any> {
    const overlays = OverlayPGIS.getInstance(this.view, this.fmap)
    return await overlays.showOverlays(param)
  }

  /*************************overlaysCluster ********/
  public async addOverlaysCluster(
    params: IOverlayClusterParameter
  ): Promise<IResult> {
    return { status: 0, message: '' }
  }
  public async deleteOverlaysCluster(params: IOverlayDelete) {}
  public async deleteAllOverlaysCluster() {}

  /*************************feature***********/
  public async findFeature(params: IFindParameter): Promise<IResult> {
    const overlay = OverlayPGIS.getInstance(this.view, this.fmap)
    return await overlay.findFeature(params)
  }
  public async findLayerFeature(params: IFindParameter) {}

  /************************************pic */
  public async changePicById(params: IPicChangeParameter): Promise<IResult> {
    const overlay = OverlayPGIS.getInstance(this.view, this.fmap)
    return await overlay.changePicById(params)
  }

  /*************************heatmap ***********/
  public async addHeatMap(params: IHeatParameter): Promise<IResult> {
    const heatmap = HeatMapPGIS.getInstance(this.view, this.fmap)
    return await heatmap.addHeatMap(params)
  }
  public async deleteHeatMap(params: ILayerConfig) {}

  /****************************geometry search */
  public async startGeometrySearch(
    params: IGeometrySearchParameter
  ): Promise<any> {
    const geometrySearch = GeometrySearchPGIS.getInstance(this.view, this.fmap)
    return await geometrySearch.startGeometrySearch(params)
  }
  public clearGeometrySearch() {
    const geometrySearch = GeometrySearchPGIS.getInstance(this.view, this.fmap)
    return geometrySearch.clearGeometrySearch()
  }
  public async backgroundGeometrySearch(
    params: IGeometrySearchParameter
  ): Promise<any> {
    const geometrySearch = GeometrySearchPGIS.getInstance(this.view, this.fmap)
    return await geometrySearch.backgroundGeometrySearch(params)
  }
  public async nearGeometrySearch(
    params: IGeometrySearchParameter
  ): Promise<IResult> {
    const geometrySearch = GeometrySearchPGIS.getInstance(this.view, this.fmap)
    return await geometrySearch.nearGeometrySearch(params)
  }

  /****************************polyline ranging********/
  public async polylineRanging(
    params: IPolylineRangingParameter
  ): Promise<any> {
    const polylineRanging = PolylineRangingPGIS.getInstance(
      this.view,
      this.fmap
    )
    return await polylineRanging.polylineRanging(params)
  }
  public async stopPolylineRanging(): Promise<IResult> {
    const polylineRanging = PolylineRangingPGIS.getInstance(
      this.view,
      this.fmap
    )
    return await polylineRanging.stopPolylineRanging()
  }
  public async clearRangingResults(): Promise<IResult> {
    const polylineRanging = PolylineRangingPGIS.getInstance(
      this.view,
      this.fmap
    )
    return await polylineRanging.clearRangingResults()
  }

  /************************************* map ********/
  public async setMapCenter(params: IPointGeometry) {
    let x = params.x
    let y = params.y
    // if (!isNaN(x) && !isNaN(y)) {
    //   const geom = new ol.geom.Point([x, y]);
    //   this.view.getView().fit(geom, { maxZoom: this.view.getView().getZoom() });
    // }
    var result = this.fmap.setMapLocation({
      center: [x, y], //地图中心点坐标，如果有z值，则zoom值无效
      duration: 200 //时长毫秒，定位到指定位置的移动效果
    })
  }
  public async setMapCenterAndLevel(params: ICenterLevel) {
    let x = params.x
    let y = params.y
    let level = params.level || this.view.getView().getZoom()
    // if (!isNaN(x) && !isNaN(y)) {
    //   const geom = new ol.geom.Point([x, y]);
    //   this.view.getView().fit(geom, { maxZoom: level });
    // }
    var result = this.fmap.setMapLocation({
      center: [x, y], //地图中心点坐标，如果有z值，则zoom值无效
      zoom: level,
      duration: 200 //时长毫秒，定位到指定位置的移动效果
    })
  }
  public setMapStyle(param: string) {
    this.view.changeBasemap(param)
  }

  /***************************track playback********/
  public async stopTrackPlayback(): Promise<IResult> {
    const trackPlayback = TrackPlaybackPGIS.getInstance(this.view, this.fmap)
    return await trackPlayback.stopTrackPlayback()
  }

  public async startTrackPlayback(
    param: ITrackPlaybackParameter
  ): Promise<IResult> {
    const trackPlayback = TrackPlaybackPGIS.getInstance(this.view, this.fmap)
    return await trackPlayback.startTrackPlayback(param)
  }

  /************************************ route ********/
  public async routeSearch(param: any): Promise<any> {
    const route = RoutePGIS.getInstance(this.view, this.fmap)
    return await route.routeSearch(param)
  }
  public clearRouteSearch(param?: IOverlayDelete): void {
    const route = RoutePGIS.getInstance(this.view, this.fmap)
    route.clearRouteSearch(param)
  }
  public showRoutePoint(params: any) {}
  public clearRoutePoint() {}

  /************************************* poi ********/
  public async searchBoundary(params: IBoundary): Promise<any> {
    const poi = POISearchPGIS.getInstance(this.view, this.fmap)
    return await poi.searchBoundary(params)
  }

  /*************************************draw overlays*/
  public async startDrawOverlays(params: IDrawOverlays): Promise<void> {
    const drawOverlays = DrawOverlaysPGIS.getInstance(this.view, this.fmap)
    drawOverlays.drawCallback = this.drawCallback
    return await drawOverlays.startDrawOverlays(params)
  }
  public async stopDrawOverlays(): Promise<void> {
    const drawOverlays = DrawOverlaysPGIS.getInstance(this.view, this.fmap)
    return await drawOverlays.stopDrawOverlays()
  }
  public async deleteDrawOverlays(params: IOverlayDelete): Promise<void> {
    const drawOverlays = DrawOverlaysPGIS.getInstance(this.view, this.fmap)
    return await drawOverlays.deleteDrawOverlays(params)
  }
  public async getDrawOverlays(): Promise<IResult> {
    const drawOverlays = DrawOverlaysPGIS.getInstance(this.view, this.fmap)
    return await drawOverlays.getDrawOverlays()
  }

  /***************************************tooltips */
  public async closeAllTooltips(): Promise<IResult> {
    const tooltips = OverlayPGIS.getInstance(this.view, this.fmap)
    return await tooltips.closeAllTooltips()
  }
  public async closeTooltips(): Promise<IResult> {
    const tooltips = OverlayPGIS.getInstance(this.view, this.fmap)
    return await tooltips.closeTooltips()
  }
  public async closePopup() {
    const tooltips = OverlayPGIS.getInstance(this.view, this.fmap)
    tooltips.closePopup()
  }
  public async showPopup(params: IPopUpTemplate) {}

  /***************************spectial overlays */
  // public async addCIMOverlays(params: IHomeGISLayer): Promise<IResult> {
  //   const overlaysLayer = HomeOverlayPGIS.getInstance(this.view, this.fmap);
  //   return await overlaysLayer.addCIMOverlays(params);
  // }
  // public async addParkOverlays(params: IHomeGISLayer): Promise<IResult> {
  //   const overlaysLayer = HomeOverlayPGIS.getInstance(this.view, this.fmap);
  //   return await overlaysLayer.addParkOverlays(params);
  // }
  // public async addDJOverlays(params: IHomeGISLayer): Promise<IResult> {
  //   const overlaysLayer = HomeOverlayPGIS.getInstance(this.view, this.fmap);
  //   return await overlaysLayer.addDJOverlays(params);
  // }
  // public async addKKOverlays(params: IHomeGISLayer): Promise<IResult> {
  //   const overlaysLayer = HomeOverlayPGIS.getInstance(this.view, this.fmap);
  //   return await overlaysLayer.addKKOverlays(params);
  // }
  // public async addQJOverlays(params: IHomeGISLayer): Promise<IResult> {
  //   const overlaysLayer = HomeOverlayPGIS.getInstance(this.view, this.fmap);
  //   return await overlaysLayer.addQJOverlays(params);
  // }
  // public async addTWOverlays(params: IHomeGISLayer): Promise<IResult> {
  //   const overlaysLayer = HomeOverlayPGIS.getInstance(this.view, this.fmap);
  //   return await overlaysLayer.addTWOverlays(params);
  // }

  /*********************************widgets */
  public showWidgetTools(params: Array<IWidget>) {
    let tool = WidgetsManagerPGIS.getInstance(this.view)
    tool.initWidgets(params)
  }
  public toggleWidget(params: string[]) {
    let tool = WidgetsManagerPGIS.getInstance(this.view)
    tool.toggleWidget(params)
  }

  /*********************************layer */
  public showLayer(params: ILayerConfig) {
    this.fmap.basisMapService.basemaplayers.forEach((baselayer: any) => {
      if (params.label && baselayer.label === params.label) {
        baselayer.setVisible(true)
      }
    })
  }
  public hideLayer(params: ILayerConfig) {
    this.fmap.basisMapService.basemaplayers.forEach((baselayer: any) => {
      if (params.label && baselayer.label === params.label) {
        baselayer.setVisible(false)
      }
    })
  }
  public async addDrawLayer(params: any): Promise<IResult> {
    return { status: 0, message: '' }
  }
  public clearDrawLayer(params: ILayerConfig) {}

  /////////////////////////////////////////////////////////////////////////////////////////////
  public async showJurisdiction() {}
  public async hideJurisdiction() {}
  public async showDistrictMask(param: IDistrictParameter) {}
  public async hideDistrictMask() {}
  public async showRoad(param: { ids: string[] }) {}
  public async hideRoad() {}
  public async showStreet() {}
  public async hideStreet() {}
  public async locateStreet(param: IStreetParameter) {}
  public showMigrateChart(params: any) {}
  public hideMigrateChart() {}
  public showBarChart(params: any) {}
  public hideBarChart() {}
  public addHeatImage(params: IHeatImageParameter) {}
  public deleteHeatImage() {}
  public async showDgene(params: any): Promise<IResult> {
    return { status: 0, message: '' }
  }
  public hideDgene() {}
  public async addDgeneFusion(params: any): Promise<IResult> {
    return { status: 0, message: '' }
  }
  public async restoreDegeneFsion(): Promise<IResult> {
    return { status: 0, message: '' }
  }
  public showCustomTip(params: ICustomTip) {}
  public showDgeneOutPoint(params: any) {}
  public changeDgeneOut() {}
  public async initializeRouteSelect(params: ISelectRouteParam) {}
  public async showSelectedRoute(params: ISelectRouteResult) {}
  public async playSelectedRoute(speed: number) {}
  public stopPlaySelectedRoute() {}
  public async routeHitArea(params: ISelectRouteHitTest): Promise<IResult> {
    return { status: -1, message: '' }
  }
  public async areaHitRoute(params: ISelectRouteHitTest): Promise<IResult> {
    return { status: -1, message: '' }
  }
  public async startLayerSearch(
    params: IGeometrySearchParameter
  ): Promise<IResult> {
    return { status: 0, message: '' }
  }
  public async startLayerDefinition(
    params: IDefinitionParameter
  ): Promise<void> {}
  public async startTrackPlay(params: ITrackParameter): Promise<void> {}
  public async getRegionOverlays(params: IOverlayParameter): Promise<IResult> {
    return { status: 0, message: '' }
  }
  public async connectSumoSimulation(
    params: ISumoConnectInfo
  ): Promise<IResult> {
    return { status: 0, message: '' }
  }
  public async addAnimatePoints(params: IOverlayParameter): Promise<IResult> {
    return { status: -2, message: 'no function' }
  }
  public async deleteAnimatePoints(params?: IOverlayDelete): Promise<IResult> {
    return { status: -2, message: 'no function' }
  }
  public async startSignalPhase(params: ISignalPhaseInfo): Promise<IResult> {
    return { status: -2, message: 'no function' }
  }
}
